import {
  CONSUMER_TIERS,
  PAID_CONSUMER_TIERS,
  type ConsumerTier,
  type PaidConsumerTier,
  isConsumerTier,
  isPaidConsumerTier,
} from "@pulse/shared";

export {
  CONSUMER_TIERS,
  PAID_CONSUMER_TIERS,
  type ConsumerTier,
  type PaidConsumerTier,
  isConsumerTier,
  isPaidConsumerTier,
};

export const CONSUMER_TIER_LABELS: Record<ConsumerTier, string> = {
  free: "Pulse Free",
  member: "Pulse Member",
  circle_plus: "Pulse Circle+",
  elite: "Pulse Elite",
};

export const CONSUMER_TIER_PRICES_CHF: Record<PaidConsumerTier, string> = {
  member: "2.99",
  circle_plus: "6.99",
  elite: "9.99",
};

export const CONSUMER_STRIPE_PRICE_IDS: Record<PaidConsumerTier, string> = {
  member: "price_1Tk6w2HV8rm91FrWLefq7TwX",
  circle_plus: "price_1Tk6wXHV8rm91FrWf49qIxFd",
  elite: "price_1Tk6xUHV8rm91FrWqJScKzC9",
};

export function consumerTierLabel(tier: string | null | undefined): string {
  if (tier && isConsumerTier(tier)) return CONSUMER_TIER_LABELS[tier];
  return "Kein Abo";
}

export function formatConsumerPrice(tier: PaidConsumerTier): string {
  return `CHF ${CONSUMER_TIER_PRICES_CHF[tier]}/Mo.`;
}

export { formatSubscriptionDate } from "@/lib/format";

export function daysUntil(iso: string): number {
  const diff = new Date(iso).getTime() - Date.now();
  return Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
}
